import { defineComponent as _defineComponent } from 'vue'
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';

interface Emits {
  (e: 'onModalClose'): void;
  (e: 'onConfirmClick'): void;
}
interface Props {
  isModalOpen: boolean;
  variant?: 'info' | 'success' | 'danger' | 'warning';
  title?: string;
  description?: string;
  confirm?: {
    label: string;
    disabledMessage?: string;
  };
  cancel?: {
    label: string;
    disabledMessage?: string;
  };
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcConfirmModal.ts',
  props: {
    isModalOpen: { type: Boolean },
    variant: { default: 'info' },
    title: null,
    description: null,
    confirm: null,
    cancel: null
  },
  emits: ["onModalClose", "onConfirmClick"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'onModalClose'): void;
  (e: 'onConfirmClick'): void;
}), expose: any, slots: any, attrs: any }) {





return { __sfc: true,emits, CcIcon }
}

})